<style scoped>
  .clearfix:after,
  .clearfix:before {
    content: ''; /*IE6，7下不兼容*/
    display: table;
  }

  .clearfix:after {
    clear: both;
  }

  .clearfix {
    *zoom: 1;
  }

  .el-form-item {
    margin-bottom: 15px !important;
  }
  .row{
    margin-top: 5px;
    height: auto;
  }
  .el-dialog__body{
    height: 600px;
    overflow: auto;
  }
  .tdStyle{
    font-weight: 900;
    font-size: 14px;
    margin-left: 5px;
  }
  .tdStyleInfo{
    margin-left: 5px;
    font-size: 14px;
  }
  table{
    width: 100%;
    height: auto;
  }
  .InfoStyle{
    width: 100%;
    margin-top: 10px;
  }
  .InfoTitleStyle{
    font-size: 15px;
    font-weight: 900;
  }
  .InfoInfoStyle{
    font-size: 12px;
    padding-left: 25px;
    padding-right: 25px;

  }
  .tooltipStyle{
    display: inline-block;
  }
  .NewsRow{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 25px;
    margin-right: 25px;
  }
  .NewsRowTitle{
    width: 120px;
    height: 50px;
    line-height: 50px;
  }
  .NewsRowInfo{
    width: 100%;
    height: auto;
  }
  .itemBox{
    display: inline-block;
    margin-right: 25px;
    line-height: 50px;
  }
  .rowStyle{
    margin-bottom: 20px;
    color: #4D4D4D;line-height: 44px;font-size: 16px;
    background: white;margin:5px;padding: 5px;
    border: 1px solid rgba(223,227,232,1);display: flex;
  }

  /*图片列表*/
  .search-row{
    display: flex;
    width: 1000px;
    margin-bottom: 26px;
    margin-left: 32px;
  }
  .floatBox{
    height: 200px;
    position: relative;
    margin-left: 20px;
  }

  .back >>> .el-icon-arrow-left,
  .next >>> .el-icon-arrow-right {
    font-size: 30px;
    cursor: pointer;
  }

  .back,
  .next,
  .picBox {
    position: absolute;
    float: left;
  }

  .back {
    left: 0px;
  }

  .next,
  .back {
    top: 50%;
    transform: translateY(-50%);
  }

  .next {
    right: 0px;
  }

  .picBox ul,
  .picBox li {
    list-style: none;
  }

  .picBox {
    width: 930px;
    left: 50%;
    transform: translateX(-50%);
    overflow: hidden;
  }

  .limit-width {
    width: 930px;
    height: 300px;
    white-space: nowrap;
    left: 150px;
  }

  .pic-item {
    /*width: 221px;
    height: 125px;*/
    width: 290px;
    height: 300px;
    /*border: 1px solid black;*/
    display: inline-block;
    margin-right: 20px;
    position: relative;
  }

  .pic-item img {
    width: 100%;
    height: 200px;
  }

  .shade {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
  }

  .shade:hover {
    background-color: rgba(0, 0, 0, 0.2);
  }

  .shade >>> .el-icon-arrow-right ,
  .shade >>> .el-icon-arrow-left {
    position: absolute;
    right: 8px;
    top: 8px;
    color: white;
    font-size: 16px;
    cursor: pointer;
  }
  /*图片列表*/
  .lineBox{
    display: flex;
    width: 1050px;
    height: 220px;
    padding: 10px;
  }
  .rightBox{

    margin-left: 10px;
    font-size: 16px;
    line-height: 30px;

  }
  .outList{
    display: flex;
    height: 700px;
    overflow: hidden;
    margin-bottom: 30px;
  }
  .list{
    height: 5000px;
    width: 100%;
    /*border: 1px solid yellow;*/
    position: relative;
    transition: left 1.5s linear; /*过度时间，即变化时间为1.5s*/
  }
</style>

<template>
  <div id="index_page"
       v-loading.fullscreen.lock="fullscreenLoading"
       element-loading-text="处理中…… 请耐心等待"
       element-loading-spinner="el-icon-loading">
    <div style="width: 100%;height: 100%;">
      <div class="w1300">

        <!--<div id="nav-header" style="display: flex;justify-content: center">
          <div style="width: 1060px;text-align: left">仪器管理 <span class="en-name">EQU MANAGE</span></div>
        </div>-->
        <div id="detail-content">
          <div id="left-nav">
            <div id="nav-body">
              <div :class="{'active':showType=='1','nav-every':true}" @click="changeType('1')">
                仪器管理
              </div>
              <div :class="{'active':showType=='2','nav-every':true}" @click="changeType('2')">
                热门仪器
              </div>
              <div :class="{'active':showType=='3','nav-every':true}" @click="changeType('3')">
                使用中仪器
              </div>
              <div :class="{'active':showType=='4','nav-every':true}" @click="changeType('4')">
                服务指南
              </div>
              <div :class="{'active':showType=='5','nav-every':true}" @click="changeType('5')">
                技术前沿
              </div>
              <div :class="{'active':showType=='6','nav-every':true}" @click="changeType('6')">
                收费标准
              </div>
            </div>
          </div>

          <div id="right-content" style="width: 1120px;overflow:hidden;">
            <div v-show="showType=='1'">
              <!--仪器展示-->
              <div id="leftTree" class="leftTree"
                   style="float:left;width: 200px;max-height: 980px;height:930px;overflow: auto;box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)">
                <el-tree :data="treeData" node-key="id" default-expand-all :props="treeDataConfigure"
                         @node-click="treeDataSelect"
                         :expand-on-click-node="false" default-expand-all highlight-current
                         style="height: 100%">
                  <div class="custom-tree-node" slot-scope="{ node, data }">
            <span style="display: flex">
                <div class="treeIcon" style="margin-top: 3px;margin-right: 3px;width: 18px;height: 16px">
                          <img v-if="data.type == 1" src="../img/tree/orgType-1.png" alt=""
                               style="width: 100%;height: 100%">
                          <img v-if="data.type == 2" src="../img/tree/orgType-2.png" alt=""
                               style="width: 100%;height: 100%">
                          <img v-if="data.type == 3" src="../img/tree/orgType-3.png" alt=""
                               style="width: 100%;height: 100%">
                          <img v-if="data.type == 4" src="../img/tree/orgType-4.png" alt=""
                               style="width: 100%;height: 100%">
                          <img v-if="data.type == 5" src="../img/tree/orgType-5.png" alt=""
                               style="width: 100%;height: 100%">
                        </div>
                <span style="font-size: 14px">{{ node.label }}</span>
            </span>
                  </div>
                </el-tree>
              </div>
              <div id="rightTable" class="searchAndTable" style="float:left;width: calc(100% - 220px);padding: 0px 10px">
                <div
                  style="width: calc(100% - 20px);height: 40px;padding: 10px 0px;display: flex;justify-content: flex-end">
                  <el-form :inline="true">
                    <el-form-item>
                      <el-input placeholder="仪器名称/项目名称" style="width: 180px" size="small"
                                v-model="queryEqu.equName"></el-input>
                    </el-form-item>
                    <el-form-item v-show="loginStatus=='2'">
                      <el-select v-model="queryEqu.applyType" size="small" placeholder="预约类型" style="width: 180px">
                        <el-option
                          v-for="item in applyList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item v-show="loginStatus=='2'">
                      <el-date-picker
                        v-model="queryEqu.openTimeRange"
                        type="daterange"
                        size="small"
                        value-format="yyyy-MM-dd"
                        format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开放开始时间"
                        end-placeholder="开放结束时间">
                      </el-date-picker>
                    </el-form-item>

                    <el-form-item>
                      <el-button type="primary" size="small" @click="searchButton">搜索仪器</el-button>
                    </el-form-item>
                  </el-form>
                </div>
                <div style="width: calc(100% - 20px);height: 790px;padding: 10px 0px;overflow: auto">
                  <div style="height: 200px;width: 100%;border-bottom:1px solid #E7E7E7;margin-top: 10px;display: flex"
                       v-for="(item,index) in bigEquList">
                    <div
                      style="width: 380px;height: 180px;margin: 10px;display: flex;justify-content: center;align-items: center">
                      <img v-if="item.equPicture" :src="'/mainsys/UserFiles/equphoto/'+item.equPicture" alt=""
                           style="width: auto;height: auto;max-height: 100%;max-width: 100%">
                      <img v-if="!item.equPicture" src="../img/lab/labimg.png" alt=""
                           style="width: auto;height: auto;max-height: 100%;max-width: 100%">
                    </div>
                    <div style="width: calc(100% - 400px);height: 180px;margin: 10px">
                      <div class="row"><span
                        style="font-size: 25px;font-weight: 900;font-family: 黑体">{{item.equName}}</span></div>
                      <div class="row">
                        <span style="font-size: 14px;font-family: 黑体">仪器编号：{{item.equNumber}}</span>
                        <span style="font-size: 14px;font-family: 黑体;margin-left: 50px">型号：{{item.equModel}}</span>
                      </div>
                      <div class="row">
                        <span style="font-size: 14px;font-family: 黑体">负责人：{{item.principal?item.principal:'暂无负责人'}}</span>
                        <span style="font-size: 14px;font-family: 黑体;margin-left: 50px">所属实验室：{{item.labName}}</span>
                      </div>
                      <div class="row" v-show="loginStatus=='2'"><span style="font-size: 14px;font-family: 黑体">购置时间：{{new Date(item.addDate).format('yyyy-MM-dd HH:mm:ss')}}</span>
                      </div>
                      <div class="row">
                        <span
                          style="font-size: 14px;font-family: 黑体;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                          :title="item.equSpec">
                          仪器说明：{{item.equSpec}}
                        </span>
                      </div>
                      <div class="row">
                        <el-button size="small" type="primary" @click="getInfo(item)">详情</el-button>
                        <el-button size="small" type="primary" style="margin-left: 30px" @click="toApply('1',item)">仪器预约
                        </el-button>
                        <el-button size="small" type="primary" style="margin-left: 30px" @click="toApply('2',item)">送样预约
                        </el-button>
                        <el-tooltip placement="right-start"
                                    effect="light"
                                    v-show='canSeePhone'
                                    class="tooltipStyle">
                          <div slot="content" style="display: flex;max-height:300px;overflow-y: auto;">
                            <template>
                              <el-table
                                :data="phoneData"
                                style="width: 100%">
                                <el-table-column
                                  prop="date"
                                  label="时间段"
                                  width="180">
                                </el-table-column>
                                <el-table-column
                                  prop="name"
                                  label="联系人"
                                  width="180">
                                </el-table-column>
                                <el-table-column
                                  prop="phone"
                                  label="电话">
                                </el-table-column>
                              </el-table>
                            </template>
                          </div>
                          <div>
                            <!--需要嵌套 否则只显示一条数据-->
                            <el-button size="small" type="primary" style="margin-left: 30px" @click="getInfo(item)">
                              联系人电话
                            </el-button>
                          </div>
                        </el-tooltip>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style="width: calc(100% - 20px);height: 40px;padding: 10px 0px;display: flex;justify-content: flex-end">
                  <el-row class="pageStyle">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                                   :current-page="queryEqu.page"
                                   :page-sizes="[5, 10, 20, 50]" :page-size="queryEqu.pageSize"
                                   layout="total, sizes, jumper, prev, pager, next" :total="total" background>
                    </el-pagination>
                  </el-row>
                </div>
              </div>
            </div>

            <div v-show="showType=='2'" style="padding-left: 10px;margin-top: 30px;">
              <!--热门仪器-->
              <div class="search-row floatBox"
                   @mouseover="clearTime()"
                   @mouseleave="startTime()">
                <!--    照片墙↓-->
                <div class="back"
                     @click="goLast"
                     v-show="photoList.length > 3">
                  <i class="el-icon-arrow-left"></i>
                </div>
                <div class="picBox">
                  <ul class="limit-width"
                      :style="{marginLeft: marLef + 'px'}">
                    <div v-if="!photoList.length"
                         style="width:290px;height:200px;
                                         line-height:200px;text-align:center;
                                         background-color:#eaedf1;
                                         font-size:18px;">暂无数据
                    </div>
                    <li v-if="photoList.length"
                        class="pic-item"
                        v-for="(item,index) in photoList"
                        :key="index">
                      <img v-if="item.EQU_PICTURE" :src="'/mainsys/UserFiles/equphoto/'+item.EQU_PICTURE"
                           @click="showDetail(item)"
                           alt="仪器照片">
                      <img v-if="!item.EQU_PICTURE" src="../img/lab/labimg.png" alt="">
                      <p style="font-size: 25px;font-weight: 900;font-family: 黑体">
                        {{item.EQU_NAME}}
                      </p>
                      <el-button size="small" type="primary" @click="getInfo(item,'ID')">详情</el-button>
                      <!--<p> <span>总使用机时：</span>  <span>{{item.all}}</span></p>
                      <p> <span>预约人次：</span>  <span>{{item.order}}</span></p>
                      <p> <span>收藏人次：</span>  <span>{{item.collect}}</span></p>-->
                    </li>
                  </ul>
                </div>
                <div class="next"
                     @click="goNext"
                     v-show="photoList.length > 3">
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </div>

            <div v-show="showType=='3'" class="outList"
                 @mouseover="clearTime('use')"
                 @mouseleave="startTime('use')">
              <!--使用中仪器-->
              <div class="list"
                   :style="{marginTop: marginTop}">
                <div v-for="(item,index) in bigEquList"
                     :key="index"
                     class="lineBox">
                  <img :src="'/mainsys/UserFiles/equphoto/'+item.equPicture"
                       v-if="item.equPicture"
                       style="width: 290px;height: 200px;"
                       @click="showDetail(item)"
                       alt="仪器照片">
                  <img src="../img/lab/labimg.png"
                       v-if="!item.equPicture"
                       style="width: 290px;height: 200px;"
                       @click="showDetail(item)"
                       alt="仪器照片">
                  <div class="rightBox">
                    <div class="row"><span
                      style="font-size: 25px;font-weight: 900;font-family: 黑体">{{item.equName}}</span></div>
                    <div class="row">
                      <span style="font-size: 14px;font-family: 黑体">仪器编号：{{item.equNumber}}</span>
                      <span style="font-size: 14px;font-family: 黑体;margin-left: 50px">型号：{{item.equModel}}</span>
                    </div>
                    <div class="row">
                      <span style="font-size: 14px;font-family: 黑体">负责人：{{item.principal?item.principal:'暂无负责人'}}</span>
                      <span style="font-size: 14px;font-family: 黑体;margin-left: 50px">所属实验室：{{item.labName}}</span>
                    </div>
                    <div class="row" v-show="loginStatus=='2'"><span style="font-size: 14px;font-family: 黑体">购置时间：{{new Date(item.addDate).format('yyyy-MM-dd HH:mm:ss')}}</span>
                    </div>
                    <div class="row">
                        <span
                          style="font-size: 14px;font-family: 黑体;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                          :title="item.equSpec">
                          仪器说明：{{item.equSpec}}
                        </span>
                    </div>
                    <el-button size="small" type="primary" @click="getInfo(item)">详情</el-button>
                  </div>
                </div>
              </div>
              <div>
                <i class="el-icon-arrow-up" @click='leftbtn' style="display: block;font-size: 40px; font-weight: 700;margin-top: 100px;"></i>
                <i class="el-icon-arrow-down"  @click='rightbtn' style="display: block;font-size: 40px;font-weight: 700;margin-top: 20px;"></i>
              </div>
            </div>

            <div v-show="showType=='4'" style="padding-left: 10px">
              <!--服务指南-->
              <div style="margin:10px 25px;height: auto;font-size: 20px;cursor:pointer;"
                   v-for="(item,index) in fileList"
                   :key="index">
                <p style="margin-right: 5px;cursor: pointer;padding-bottom: 10px;color:#7b96b1;border-bottom: 1px dashed #D9D9D9;"
                   @click="downloadFile(item)">{{item.fileName}}
                </p>
              </div>
            </div>

            <div v-show="showType=='5'" style="padding-left: 10px">
              <!--技术前沿-->
              <ul id="article-list">
                <li class="article-li" v-for="(item,i) in techList">
                  <a class="article-title" @click="toDetail(item.id,item.title)"
                     :title="item.title" style="text-align: left">{{item.title}}</a>
                  <a class="article-time">{{item.createDate}}</a>
                </li>
              </ul>
            </div>

            <div v-show="showType=='6'" style="padding-left: 10px">
              <div v-for="(item,index) in EquBillList" :key="index"
                   class="clearfix rowStyle">
                <p style="width: 200px;font-size: 24px;margin: 8px;word-wrap: break-word;">{{item.equName}}</p>
                <div>
                  <div v-for="(childItem,childIndex) in item.largeInsBillings"
                       style="border-bottom: 1px solid #3B83BB;
                       padding-bottom: 10px;
                       margin-bottom: 10px;"
                       :key="childIndex">
                    <p class="itemBox">
                      <span style="color: rgba(128,128,128,1)">用户类型:</span>
                      <span style="margin-left: 5px">{{childItem.userTypeName}}</span>
                    </p>

                    <p class="itemBox">
                      <span style="color: rgba(128,128,128,1)">计费单位:</span>
                      <span style="margin-left: 5px">{{childItem.orgName}}</span>
                    </p>

                    <p class="itemBox">
                      <span style="color: rgba(128,128,128,1)">预约类型:</span>
                      <span style="margin-left: 5px" v-show="childItem.billingType=='Instruments'">仪器预约</span>
                      <span style="margin-left: 5px" v-show="childItem.billingType=='samples'">送样预约</span>
                    </p>

                    <p class="itemBox">
                      <span style="color: rgba(128,128,128,1)">计费方式:</span>
                      <span style="margin-left: 5px" v-show="childItem.sampleBilling">样品计费</span>
                      <span style="margin-left: 5px" v-show="childItem.timeBilling">时间计费（分钟）</span>
                      <span style="margin-left: 5px" v-show="childItem.numberBilling">次数计费</span>
                    </p>

                    <p class="itemBox" v-if="childItem.isSegmentation=='0'">
                      <span style="color: rgba(128,128,128,1)">是否分段计费:</span>
                      <span style="margin-left: 5px" v-show="childItem.isSegmentation=='1'">是</span>
                      <span style="margin-left: 5px" v-show="childItem.isSegmentation=='0'">否</span>
                    </p>

                    <p  v-if="childItem.isSegmentation=='1'">
                      <span style="color: rgba(128,128,128,1)">是否分段计费:</span>
                      <span style="margin-left: 5px" v-show="childItem.isSegmentation=='1'">是</span>
                      <span style="margin-left: 5px" v-show="childItem.isSegmentation=='0'">否</span>

                      <el-table :data="childItem.segmentedBilling">
                        <el-table-column min-width="100" property="userName" label="开始时间">
                          <template slot-scope="scope">
                            <span>{{scope.row.startTime}}</span>
                          </template>
                        </el-table-column>
                        <el-table-column min-width="100" property="userName" label="结束时间">
                          <template slot-scope="scope">
                            <span>{{scope.row.endTime}}</span>
                          </template>
                        </el-table-column>

                        <el-table-column min-width="100" property="userName" label="价格（元）">
                          <template slot-scope="scope">
                            <span>{{scope.row.price}}</span>
                          </template>
                        </el-table-column>

                        <el-table-column min-width="100" property="userName" label="备注">
                          <template slot-scope="scope">
                            <span>{{scope.row.remark}}</span>
                          </template>
                        </el-table-column>
                      </el-table>
                    </p>

                    <p class="itemBox">
                      <span style="color: rgba(128,128,128,1)">计费价格（元）:</span>
                      <span style="margin-left: 5px">{{childItem.price}}</span>
                    </p>

                    <p class="itemBox">
                      <span style="color: rgba(128,128,128,1)">附加收费项目:</span>
                      <span style="margin-left: 5px">{{childItem.costItemName}}</span>
                    </p>

                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="设备详情"
      :visible.sync="dialogVisible"
      width="1200px">
      <!--原来的表格-->
      <!--<table border="1" cellspacing="0" cellpadding="0" style="border-color:#EBEEF5">
        <tr style="height: 30px;line-height: 30px">
          <td><span class="tdStyle">设备编号</span></td>
          <td><span class="tdStyleInfo">{{bigEquInfo.equSpec}}</span></td>
          <td><span class="tdStyle">设备名称</span></td>
          <td><span class="tdStyleInfo">{{bigEquInfo.equName}}</span></td>
          <td colspan="2" rowspan="7">
            <div class="tdStyleInfo" style="display: flex;justify-content: center;align-items: center;">
            <img v-if="bigEquInfo.equPicture" :src="'/mainsys/UserFiles/equphoto/'+bigEquInfo.equPicture" alt="" style="width: auto;height: auto;max-height: 220px;max-width: 270px">
            <img v-if="!bigEquInfo.equPicture" src="../img/lab/labimg.png" alt="" style="width: auto;height: auto;max-height: 220px;max-width: 270px">
          </div>
          </td>
        </tr>
        <tr style="height: 30px;line-height: 30px">
          <td><span class="tdStyle">设备分类号</span></td>
          <td><span class="tdStyleInfo">{{bigEquInfo.equSortNum}}</span></td>
          <td><span class="tdStyle">设备特征</span></td>
          <td><span class="tdStyleInfo">{{bigEquInfo.equTz}}</span></td>
        </tr>
        <tr style="height: 30px;line-height: 30px">
          <td><span class="tdStyle">型号</span></td>
          <td><span class="tdStyleInfo">{{bigEquInfo.equModel}}</span></td>
          <td><span class="tdStyle">规格</span></td>
          <td><span class="tdStyleInfo">{{bigEquInfo.equSpec}}</span></td>
        </tr>
        <tr style="height: 30px;line-height: 30px">
          <td><span class="tdStyle">设备单价</span></td>
          <td><span class="tdStyleInfo">{{bigEquInfo.equPrice}}</span></td>
          <td><span class="tdStyle">使用方向</span></td>
          <td><span class="tdStyleInfo">{{bigEquInfo.equUseway}}</span></td>
        </tr>
        <tr style="height: 30px;line-height: 30px">
          <td><span class="tdStyle">生产厂家</span></td>
          <td><span class="tdStyleInfo">{{bigEquInfo.equMaker}}</span></td>
          <td><span class="tdStyle">国家代码</span></td>
          <td><span class="tdStyleInfo">{{bigEquInfo.equNationcode}}</span></td>
        </tr>
        <tr style="height: 30px;line-height: 30px">
          <td><span class="tdStyle">设备来源</span></td>
          <td><span class="tdStyleInfo">{{bigEquInfo.equSource}}</span></td>
          <td><span class="tdStyle">放置地点</span></td>
          <td><span class="tdStyleInfo">{{bigEquInfo.equLab}}</span></td>
        </tr>
        <tr style="height: 30px;line-height: 30px" v-show="loginStatus=='2'">
          <td><span class="tdStyle">出厂时间</span></td>
          <td><span class="tdStyleInfo">{{new Date(bigEquInfo.equReleasedate).format('yyyy-MM-dd')}}</span></td>
          <td><span class="tdStyle">入账时间</span></td>
          <td><span class="tdStyleInfo">{{new Date(bigEquInfo.equRztime).format('yyyy-MM-dd')}}</span></td>
        </tr>

        <tr style="height: 30px;line-height: 30px">
          <td><span class="tdStyle">品牌</span></td>
          <td><span class="tdStyleInfo">{{bigEquInfo.equBrand}}</span></td>
          <td><span class="tdStyle">设备性质</span></td>
          <td><span class="tdStyleInfo">{{bigEquInfo.equCharacter}}</span></td>
          <td><span class="tdStyle">经费科目</span></td>
          <td><span class="tdStyleInfo">{{bigEquInfo.equFunds}}</span></td>
        </tr>
        <tr style="height: 30px;line-height: 30px">
          <td><span class="tdStyle">负责人</span></td>
          <td><span class="tdStyleInfo">{{bigEquInfo.principal}}</span></td>
          <td><span class="tdStyle">记账人</span></td>
          <td><span class="tdStyleInfo">{{bigEquInfo.equJzr}}</span></td>
          <td><span class="tdStyle"></span></td>
          <td><span class="tdStyleInfo"></span></td>
        </tr>
        <tr style="height: 30px;line-height: 30px">
          <td><span class="tdStyle">置购时间</span></td>
          <td colspan="2"><span class="tdStyleInfo">{{new Date(bigEquInfo.addDate).format('yyyy-MM-dd')}}</span></td>
          <td><span class="tdStyle">出厂号</span></td>
          <td colspan="2"><span class="tdStyleInfo">{{bigEquInfo.equOrderform}}</span></td>
        </tr>
        <tr style="height: 30px;line-height: 30px">
          <td><span class="tdStyle">管理机MAC地址</span></td>
          <td colspan="2"><span class="tdStyleInfo">{{bigEquInfo.equMac}}</span></td>
          <td><span class="tdStyle">管理机IP地址</span></td>
          <td colspan="2"><span class="tdStyleInfo">{{bigEquInfo.equIp}}</span></td>
        </tr>
        <tr style="height: 30px;line-height: 30px">
          <td><span class="tdStyle">每小时费用</span></td>
          <td colspan="2"><span class="tdStyleInfo">{{bigEquInfo.equPayprice}}元</span></td>
          <td><span class="tdStyle">单次预约最大时间</span></td>
          <td colspan="2"><span class="tdStyleInfo">{{bigEquInfo.borrowTimeLimit}}小时</span></td>

        </tr>
        <tr style="height: 30px;line-height: 30px">
          <td><span class="tdStyle">设备条形码</span></td>
          <td colspan="5"><span class="tdStyleInfo">{{bigEquInfo.barCode}}</span></td>
        </tr>
        <tr style="height: 30px;line-height: 30px" v-show="loginStatus=='2'">
          <td><span class="tdStyle">保修截止时间</span></td>
          <td colspan="5"><span class="tdStyleInfo">{{new Date(bigEquInfo.warrantyDeadline).format('yyyy-MM-dd')}}</span></td>
        </tr>
        <tr style="height: 30px;line-height: 30px">
          <td><span class="tdStyle">主要技术指标</span></td>
          <td colspan="5"><span class="tdStyleInfo">{{bigEquInfo.equTechtarget}}</span></td>
        </tr>
        <tr style="height: 30px;line-height: 30px">
          <td><span class="tdStyle" >典型测试用例</span></td>
          <td colspan="5"><span class="tdStyleInfo">{{bigEquInfo.equUsecase}}</span></td>
        </tr>
        <tr style="height: 30px;line-height: 30px">
          <td><span class="tdStyle">仪器主要功能及描述</span></td>
          <td colspan="5"><span class="tdStyleInfo">{{bigEquInfo.equFunction}}</span></td>
        </tr>
        <tr style="height: 30px;line-height: 30px">
          <td><span class="tdStyle">设备介绍</span></td>
          <td colspan="5"><span class="tdStyleInfo">{{bigEquInfo.equIntroduce}}</span></td>
        </tr>
        <tr style="height: 30px;line-height: 30px">
          <td><span class="tdStyle">服务领域</span></td>
          <td colspan="5"><span class="tdStyleInfo">{{bigEquInfo.equServicedomain}}</span></td>
        </tr>
        <tr style="height: 30px;line-height: 30px">
          <td><span class="tdStyle">备注</span></td>
          <td colspan="5"><span class="tdStyleInfo">{{bigEquInfo.equRemark}}</span></td>
        </tr>
        <tr style="height: 30px;line-height: 30px" v-if="bigEquInfo.labCertificateInfos&&bigEquInfo.labCertificateInfos.length>0">
          <td><span class="tdStyle">证书名称</span></td>
          <td colspan="5">
            <span class="tdStyleInfo" v-for="(items,index) in bigEquInfo.labCertificateInfos">{{items.name}}</span>
          </td>
        </tr>
      </table>-->

      <iframe :src="url" style="width: 100%;min-height: 600px;margin: 0px;padding: 0px;border: 0;overflow-y: hidden"></iframe>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" style="margin-left: 30px" @click="toApply('1',bigEquInfo)" >仪器预约</el-button>
        <el-button size="small" type="primary" style="margin-left: 30px" @click="toApply('2',bigEquInfo)" >送样预约</el-button>
      </span>
    </el-dialog>

    <div v-show="showIframe">
      <iframe :src="url" style="width: 1100px;min-height: 600px;margin: 0px;padding: 0px;border: 0;overflow-y: hidden"></iframe>
    </div>

    <el-dialog
      title="技术前沿"
      :visible.sync="techDialogVisible"
      width="990px">
      <div>
        <div class="NewsRow">
          <div class="NewsRowTitle">标题</div>
          <div class="NewsRowInfo">{{tachInfo.title}}</div>
        </div>
        <div class="NewsRow">
          <div class="NewsRowTitle">内容</div>
          <div class="NewsRowInfo" v-html="tachInfo.content">{{tachInfo.content}}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="techDialogVisible = false">关 闭</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
  // 将提交数据转化为formData
  function translateForm(data) {
    var fd = new FormData();
    for (var key in data) {
      fd.append(key, data[key])
    }
    return fd;
  }

  Date.prototype.format = function (fmt) {
    var o = {
      "M+": this.getMonth() + 1, // 月份
      "d+": this.getDate(), // 日
      "h+": this.getHours()%12 == 0 ? 12 : this.getHours()%12, // 12h小时
      "H+": this.getHours(), // 24小时
      "m+": this.getMinutes(), // 分
      "s+": this.getSeconds(), // 秒
      "q+": Math.floor((this.getMonth() + 3) / 3), // 季度
      "S": this.getMilliseconds(), // 毫秒
      "E":this.getDay() // 星期
    };
    if (/(y+)/.test(fmt))
      fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
      if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
  }

  export default {
    name: "",
    data() {
      return {
        timer:'',//定时器
        /*图片列表*/
        delImgName:[],//删除的文件名
        marLef:0,
        /*仪器照片*/
        photoList:[
          {
            equName:'达尔文显微镜',
            url:require('../img/lab/labimg.png'),
            all:"5",
            order:"2",
            collect:"10",
          },
          {
            equName:'生物基因',
            url:require('../img/lab/labimg.png'),
            all:"4",
            order:"1",
            collect:"2",
          },
          {
            equName:'细菌观察仪',
            url:require('../img/lab/labimg.png'),
            all:"7",
            order:"11",
            collect:"5",
          },
          {
            equName:'电磁仪',
            url:require('../img/lab/labimg.png'),
            all:"6",
            order:"7",
            collect:"5",
          },
        ],
        useredList:[
          /*使用中仪器*/
          {
            url:require('../img/lab/labimg.png'),
            name:'色谱仪',
            model:"*",
            principal:"KRUSKOP SERGEI",
            labName:"准备间",
          },
          {
            url:require('../img/lab/labimg.png'),
            name:'细菌观察仪',
            model:"002",
            principal:"李小青",
            labName:"光谱室",
          },
          {
            url:require('../img/lab/labimg.png'),
            name:'电磁仪',
            model:"*",
            principal:"KHOROSHILTSEVA NATALIA",
            labName:"离心机、冰箱室",
          },
          {
            url:require('../img/lab/labimg.png'),
            name:'显微镜',
            model:"001",
            principal:"KRUSKOP SERGEI",
            labName:"光谱室",
          },
        ],
        additionalCostList:[],//附加收费
        tachInfo:{},//技术前沿详情
        techList:[],//技术前沿列表
        content:{},
        url:"",
        showIframe:false,
        phoneData:[],//联系人信息
        applyList:[
          {
            value:'1',
            label:"仪器预约"
          },
          {
            value:'2',
            label:"送样预约"
          }
        ],
        fullscreenLoading:false,
        dialogVisible:false,
        queryList:{},
        treeData:[],//机构树
        treeDataConfigure: {children: 'items', label: 'name'},//配置树形数据
        queryEqu:{
          beginTime:"",
          endTime:"",
          applyType:"",//预约类型
          openTimeRange:[],//开放时间段
          page: 1,
          pageSize: 5,
          orgInfos:'',
          equName:'',
        },
        total: 0,
        bigEquList:[],
        bigEquInfo:{},
        loginStatus:"",//登录状态
        canSeePhone:false,//是否可查看联系人电话
        showType:"1",
        techDialogVisible:false,//技术前沿
        fileList:[],//服务指南列表
        EquBillList:[],//设备收费标准
        orgList:[],//单位列表
        /*上下轮播图*/
        photoCount:0,//规定当前的位置
        liwidth:290,
        marginTop:0,
        hotEquCount:0,//热门仪器
      }
    },
    methods: {
      getHotEqu(){
        //获取热门仪器
        var that = this
        var fd = new FormData();
        fd.append('pageSize', '999')
        fd.append('pageNum', '1')
        var obj = {
          pageSize:'999',
          pageNum:'1'
        }
        that.fullscreenLoading = true;
        axios.post("/newEqu/getEquListByAppCount",fd).then(function (response) {
          that.fullscreenLoading = false;
          that.photoList = response.data.data
        }).catch(function (error) {
          that.fullscreenLoading = false;
          that.$message.error('数据请求失败，请重试！');
        });
      },
      getUseList(){
        //获取使用中仪器 /newEqu/getEquList

      },
      rightbtn(){
        var len = this.useredList.length
        this.photoCount++;
        if(this.photoCount>=len){
          this.photoCount = 0;
        }
        /*
            当移动到第一张图片时   ul向左移动0px  即   0 * 1000px（可视区域的宽度）
            当移动到第二张图片时   ul向左移动1000px  即   1 * 1000px （photoCount  *  liwidth ）
            当移动到第三张图片时   ul向左移动2000px  即   2 * 1000px （photoCount  *  liwidth ）
        */

        var height = 200
        this.marginTop=-200*this.photoCount+'px';
        // this.marginTop=-height*3+'px';
      },

      // 左边按钮的点击事件
      leftbtn(){
        var len = this.useredList.length
        this.photoCount--;
        if(this.photoCount<=-1){
          this.photoCount=len-1;
        }
        var height = 200
        // this.marginTop=-height*3+'px';
        this.marginTop=-height*this.photoCount+'px';
      },
      showDetail(){
        //展示热门仪器详情
      },
      //---------图片列表--------------
      //上一个
      goLast () {
        /*var that = this
        if (that.marLef == 0) {
          return;
        }
        that.marLef = that.marLef + 241;*/

        var len = this.photoList.length
        this.hotEquCount--;
        if(this.hotEquCount<=-1){
          this.hotEquCount=len-1;
        }
        this.marLef=-this.liwidth*this.hotEquCount;



      },
      //下一个
      goNext () {
        var that = this
        //还剩下四个的时候，不能再向后点击
        /*if (that.marLef == -241 * (that.photoList.length - 3) || that.photoList.length <= 3) {
          // console.log(-241 * (that.photoList.length - 4));
          return;
        }
        that.marLef = that.marLef - 241;*/

        var len = this.photoList.length
        this.hotEquCount++;
        if(this.hotEquCount>=len){
          this.hotEquCount = 0;
        }
        this.marLef=-this.liwidth*this.hotEquCount;
      },
      //---------图片列表--------------
      //获取附加费用
      getAdditionalCost(){
        var that = this;
        that.fullscreenLoading = true;
        axios.post("/newEqu/getCostItemList",{}, {
          headers: {'Content-Type': 'application/x-www-form-urlencoded'}
        }).then(function (response) {
          that.fullscreenLoading = false;
          that.additionalCostList = response.data.data;
          that.additionalCostList.forEach((item) => {
            if(!item.itemName){
              item.itemName = '-'
            }
          });
        }).catch(function (error) {
          that.fullscreenLoading = false;
          that.$message.error('获取附加费用失败，请重试！');
        });
      },
      //获取中心列表
      getOrgList(){
        var that = this;
        that.fullscreenLoading = true;
        var fd = new FormData();
        fd.append('type', '1,2,3');
        fd.append('status', '2');
        axios.post("/baseinfo/getOrgSelectFromUser", fd, {
          headers: {'Content-Type': 'application/x-www-form-urlencoded'}
        }).then(function (response) {
          that.fullscreenLoading = false;
          that.orgList = response.data;
        }).catch(function (error) {
          that.fullscreenLoading = false;
          that.$message.error('获取中心列表失败，请重试！');
        });
      },
      getEquList() {
        var that = this;
        // var fd = new FormData();
        // for(var key in that.searchFormData){
        //   fd.append(key,that.searchFormData[key])
        // };
        that.fullscreenLoading = true;
        axios.post("/newEqu/getEquList").then(function (response) {
          that.fullscreenLoading = false;
          that.EquBillList = response.data.data;
          that.EquBillList.forEach((item,index)=>{
            item.largeInsBillings.forEach((cItem,cIndex)=>{
              var userTypeName = cItem.userType=='teacher'?'教师':cItem.userType=='student'?'学生':"校外用户"
              that.$set(cItem,'userTypeName',userTypeName)
              var orgName = ''
              var delIdIndex = that.orgList.findIndex((value) => value.id == cItem.orgId);
              if(delIdIndex>=0){
                orgName = that.orgList[delIdIndex].name
              }
              that.$set(cItem,'orgName',orgName)

              if(cItem.sampleBilling){
                that.$set(cItem,'price',cItem.sampleBilling)
              }else if(cItem.timeBilling){
                that.$set(cItem,'price',cItem.timeBilling)
              }else if(cItem.numberBilling){
                that.$set(cItem,'price',cItem.numberBilling)
              };

              var costItemName = ''
              if(cItem.equExtraCharges){
                cItem.equExtraChargesList = cItem.equExtraCharges.split(',');
                cItem.equExtraChargesList.forEach((costItem,costIndex)=>{
                  var delIdIndex = that.additionalCostList.findIndex((value) => value.id == costItem);
                  if(delIdIndex>=0){
                    costItemName += that.additionalCostList[delIdIndex].itemName+','
                  }
                })
              }
              that.$set(cItem,'costItemName',costItemName)

            })
          })
        }).catch(function (error) {
          that.fullscreenLoading = false;
          that.$message.error('提交失败，请重试！');
        })
      },
      downloadFile:function(item){
        axios({
          method: 'get',
          url: '/downloadFile?fileId='+item.id,
          responseType: 'blob'
        }).then((res) => {
          if (!res) {
            return
          }
          let blob = new Blob([res.data], {
            type: "application/octet-stream"
          });
          let url = window.URL.createObjectURL(blob)
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url;
          link.setAttribute("download", item.fileName);
          document.body.appendChild(link);
          link.click();
        })
      },
      getUploadList:function(){
        //获取文件列表
        var that = this;
        var fd = translateForm({
          configItem:"workFile"
        });
        that.fullscreenLoading=true;
        axios.post("/work/selectFile",fd,{
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(function (response) {
          that.fullscreenLoading=false;
          if(response.data.data){
            that.fileList = response.data.data
          };
        }).catch(function(error){
          that.fullscreenLoading=false;
          that.$message.error('获取失败，请重试！');
        })
      },
      toDetail(id){
        //查看详情
        var that=this;
        that.techDialogVisible=true;
        axios.post("/notice/getNoticeContent/"+id+"?click=1").then(function (response) {
          that.tachInfo=response.data;
          if(that.tachInfo.noticeCourse==''||that.tachInfo.noticeCourse==null){
            that.tachInfo.noticeCourse='暂无课程'
          }
        }).catch(function (error) {
          that.fullscreenLoading = false;
          that.$message.error('数据请求失败，请重试！');
        });
      },
      getTech(){
        //获取技术前沿
        var that=this;
        that.techList = []
        that.start=(that.page-1)*that.pageSize;
        var fd = translateForm({
          start:0,
          length:999,
          model:'',
          noticeTitle:'',
          noticeState:'2',
          isShowEffective:'1',
          isRead:'1',
          type:"020205"
        });
        axios.post("/notice/getNoticeList", fd, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(function (response) {
          var total=response.data.recordsTotal;
          var NewsList=response.data.data;
          NewsList.forEach(function (item) {
            if(item.type=='020205'){
              that.techList.push(item)
            }
            // item.months=item.createDate.split('-')[1];
            // item.day=item.createDate.split('-')[2];
            // if(item.isRead != '1'){
            //   item.styles = 'font-weight: 900;color:black'
            // }
          })
        }).catch(function (error) {
          that.fullscreenLoading = false;
          that.$message.error('数据请求失败，请重试！');
        });
      },
      clearTime(val){
        if(val=='use'){
          clearInterval(this.timer);
        }else{
          clearInterval(this.timer2);
        }
      },
      startTime(val){
        if(val=='use'){
          clearInterval(this.timer);
          this.timer = setInterval(()=>{
            this.rightbtn();
          },800)
        }else{
          clearInterval(this.timer2);
          this.timer2 = setInterval(()=>{
            this.goNext();
          },800)
        }

      },
      changeType(type){
        this.showType = type
        clearInterval(this.timer);
        clearInterval(this.timer2);
        if(type=='2'){
          //热门仪器
          this.getHotEqu();
          this.timer2 = setInterval(()=>{
            this.goNext();
          },800)
        }else if(type=='3'){
          //使用中仪器
          this.searchButton();
          this.timer = setInterval(()=>{
            this.rightbtn();
          },800)
        }else if(type=='4'){
          //服务指南
          this.getUploadList();
        }else if(type=='5'){
          //技术前沿
          this.getTech();
        }else if(type=='6'){
          //收费标准
          this.getEquList();
        }
      },
      getPhone(){
        //获取联系人电话

      },
      dateToTimestamp(dateStr) {
        if (!dateStr) {
          return ''
        }
        let newDataStr = dateStr.replace(/\.|\-/g, '/')
        let date = new Date(newDataStr);
        let timestamp = date.getTime();
        return timestamp
      },
      toApply(type,item){
        if(sessionStorage.getItem('loginStatus')=='2'){
          //在登录状态下
          if(type=='1'){
            //仪器预约
            location.href =this.targetUrl+'insApply?resId=2106151635043484938&newId='+item.id+'&equId='+item.equId
          }else{
            //送样预约
            location.href =this.targetUrl+'InsSempleApply?resId=2106151635043484938&labId='+item.labId+'&equName='+item.equName+'&newId='+item.id +'&labName='+item.labName //odig-lims 配置地址
          }
        }else{
          location.href =this.targetUrl
        }
      },
      getInfo(item,type){
        var that = this;
        that.bigEquInfo = item
        if(type=='ID'){
          this.url = this.targetUrl+'insIframeInfo/cms='+item.ID
        }else{
          this.url = this.targetUrl+'insIframeInfo/cms='+item.id
        }
        that.dialogVisible = true;
        /*var fd = new FormData();
        fd.append('id',item.id)
        that.fullscreenLoading = true;
        axios.post("/equBig/getEquDetailNotStatus",fd).then(function (response) {
          that.fullscreenLoading = false;
          that.dialogVisible = true;
          that.bigEquInfo = response.data;
        }).catch(function (error) {
          console.log(error)
          that.fullscreenLoading = false;
          that.$message.error('数据请求失败，请重试！');
        })*/
      },
      treeDataSelect(data, node, com){
        var that = this;
        that.queryEqu.orgInfos = data.id
        that.searchButton();
      },
      //查询仪器设备
      searchButton(){
        console.log(this.showType);//  3使用中仪器

        var that = this;
        that.fullscreenLoading = true;
        if(that.queryEqu.openTimeRange && that.queryEqu.openTimeRange.length>0){
          that.queryEqu.beginTime = that.dateToTimestamp(that.queryEqu.openTimeRange[0]).toString()
          that.queryEqu.endTime = that.dateToTimestamp(that.queryEqu.openTimeRange[1]).toString()
        }

        var obj = {}
        if(that.showType=='3'){
          obj = {
            page: 1,
            pageSize: 999,
            isUse:'1',//使用中
          }
        }else{
          obj = that.queryEqu
        }

        var fd = new FormData();
        for(var key in obj){
          fd.append(key,obj[key])
        };

        // /equBig/getEquListNotStatus //老接口
        // /newEqu/getEquList
        axios.post("/newEqu/getOpenEquList",fd).then(function (response) {
          that.fullscreenLoading = false;
          that.bigEquList = response.data.data;
          if(sessionStorage.getItem('loginStatus')=='2'){
            //在登录状态下
            that.bigEquList.forEach((item,index)=>{
              var str = ''
              for(var i =0;i<item.equManagerRelations.length;i++){
                str+= item.equManagerRelations.length -1 != i?item.equManagerRelations[i].userName+"、":item.equManagerRelations[i].userName
                that.$set(item,'principal',str)
              }
            })
          }else{
            that.bigEquList.forEach((item,index)=>{
              var str = ''
              item.equManager.forEach((item2,index2)=>{
                  str+= item.equManager.length -1 != index2?item2+"、":item2
                  that.$set(item,'principal',str)
              })
            })
          }
          that.total = response.data.total;
        }).catch(function (error) {
          that.fullscreenLoading = false;
          that.$message.error('数据请求失败，请重试！');
        })
      },
      handleSizeChange(val){
        var that = this;
        that.queryEqu.page = 1;
        that.queryEqu.pageSize = val;
        that.searchButton();
      },
      handleCurrentChange(val){
        var that = this;
        that.queryEqu.page = val;
        that.searchButton();
      },
      //获取左边树的信息
      getLeftTree(){
        var that = this;
        that.fullscreenLoading = true;
        axios.post("/basetree/getOrgTreeAll1?showLab=false").then(function (response) {
          that.fullscreenLoading = false;
          var recData = response.data;
          that.treeData = recData;
          that.treeCycle(that.treeData)
        }).catch(function (error) {
          that.fullscreenLoading = false;
          that.$message.error('数据请求失败，请重试！');
        })
      },
      //给每级树加图标
      treeCycle:function(array){
        var that=this;
        if(array){
          for(var i=0;i<array.length;i++){
            if(array[i].typeId){
              array[i].type = array[i].typeId.id
            }else{
              array[i].id = '';
              array[i].type = 1
            }
            if(array[i].labSpecialtyInfos){
              for(var j=0;j<array[i].labSpecialtyInfos.length;j++){
                array[i].labSpecialtyInfos[j].text=array[i].labSpecialtyInfos[j].zyName;
                array[i].items.push(array[i].labSpecialtyInfos[j])
              }
            }
            that.treeCycle(array[i].items)
          }
        }

      },
    },
    created() {
      this.loginStatus = sessionStorage.getItem('loginStatus') //2在登录状态下
      this.queryEqu.applyType = this.loginStatus=='2'?'1':''
      this.getLeftTree();
      this.searchButton();
      this.getOrgList();//获取单位
      this.getAdditionalCost();//附加收费

    }
  }
</script>
